import {
  getAccessibilityWidgetProps,
  getButtonWidgetProps,
  getVerticalAndHorizontalWidgetProps,
  getModalWidgetProps,
  getBrandWidgetProps,
  getStoreLocatorWidgetProps,
} from './helpers'
import Accessibility from './components/pages/Accessibility'
import Vertical from './components/pages/Vertical'
import Horizontal from './components/pages/Horizontal'
import Button from './components/pages/Button'
import NoMatch from './components/pages/NoMatch'
import Modal from './components/pages/Modal'
import Brand from './components/pages/Brand'
import StoreLocator from './components/pages/StoreLocator'

const routes = [
  {
    path: '/accessibility',
    exact: true,
    component: Accessibility,
    loadData: (req) => getAccessibilityWidgetProps(req),
  },
  {
    path: '/modal',
    exact: true,
    component: Modal,
    loadData: (req) => getModalWidgetProps(req),
  },
  {
    path: '/button',
    exact: true,
    component: Button,
    loadData: (req) => getButtonWidgetProps(req),
  },
  {
    path: '/vertical',
    exact: true,
    component: Vertical,
    loadData: (req) => getVerticalAndHorizontalWidgetProps(req),
  },
  {
    path: '/horizontal',
    exact: true,
    component: Horizontal,
    loadData: (req) => getVerticalAndHorizontalWidgetProps(req),
  },
  {
    path: '/brands',
    exact: true,
    component: Brand,
    loadData: (req) => getBrandWidgetProps(req),
  },
  {
    path: '/store_locators',
    exact: true,
    component: StoreLocator,
    loadData: (req) => getStoreLocatorWidgetProps(req),
  },
  {
    path: '/widgets/poi',
    exact: true,
    component: Accessibility,
    loadData: (req) => getAccessibilityWidgetProps(req),
  },

  { component: NoMatch },
]

export default routes
